import { render, staticRenderFns } from "./App.vue?vue&type=template&id=eddace90&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style1 from "./App.vue?vue&type=style&index=1&id=eddace90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddace90",
  null
  
)

export default component.exports